import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class TranslatePreloadService {
    constructor(
        private translate: TranslateService,
        private languageService: LanguageService,
        @Inject(PLATFORM_ID) private platformId: object
    ) { }

    preload(): Promise<void> {
        const activeLang = this.languageService.getCurrentLanguage();
        const shouldPersist = isPlatformBrowser(this.platformId);

        return this.languageService
            .ensureLanguageLoaded(activeLang, { persist: shouldPersist, emit: false })
            .catch(() => {
                this.translate.setDefaultLang(activeLang);
                return firstValueFrom(
                    this.translate.use(activeLang).pipe(
                        map(() => void 0),
                        catchError(() => of(void 0))
                    )
                );
            });
    }
}
